import { ApiProperty } from "@nestjs/swagger";


export class unitreq{

    @ApiProperty()
    plant_id:number;
}